





































































































































































































































import TemplateEditorPlaceholderDropdown from "@/components/template/TemplateEditorPlaceholderDropdown.vue";
import SideCard from "@/components/utility/SideCard.vue";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { SignDocumentTokenDtoGen } from "@/services/sign/v1/data-contracts";
import { DocumentTemplateModule } from "@/store/modules/document-template.store";
import { FeatureModule } from "@/store/modules/feature.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import { IDocumentPageMeta } from "./DocumentDetailEditorMixin.vue";
import DocumentDetailMixin from "./DocumentDetailMixin.vue";
import DocumentTemplateDetailTokenListExpansionHeader from "./DocumentTemplateDetailTokenListExpansionHeader.vue";
import Debug from "@/components/utility/Debug.vue";
import {
  isCrossToken,
  isSignatureToken,
  isQrCodeToken,
  SignatureImageTokenConfig,
  SignatureTokenConfigType,
  SignatureQRTokenConfig
} from "@/lib/signature-token.utils";
import { SignatureTokenEnum } from "@/lib/enum/signature-token.enum";
import CustomFieldBoolean from "@/components/report/CustomFieldBoolean.vue";

@Component({
  components: {
    SideCard,
    TemplateEditorPlaceholderDropdown,
    DocumentTemplateDetailTokenListExpansionHeader,
    Debug,
    CustomFieldBoolean
  }
})
export default class DocumentTemplateDetailTokenForm extends mixins(
  DarkModeHighlightMixin,
  PermissionMixin,
  DocumentDetailMixin
) {
  readonly SignatureTokenEnum = SignatureTokenEnum;

  @Prop()
  page!: IDocumentPageMeta;

  /**
   * Edit values or allow dropdowns
   */
  @Prop({ default: false })
  isEditValue!: boolean;

  /**
   * Suppress editing of values
   */
  @Prop({ default: false })
  disabled!: boolean;

  get selectedPage() {
    return DocumentTemplateModule.currentPage;
  }

  get selectedItem() {
    return DocumentTemplateModule.highlightedToken;
  }

  get documentToken() {
    return DocumentTemplateModule.documentTokens[this.selectedPage][this.selectedItem];
  }

  isSignatureWithQR(token: SignDocumentTokenDtoGen) {
    this.$log.debug(token.token, isQrCodeToken(token.token));
    return isQrCodeToken(token.token);
  }

  change(isQrCode: boolean, token: SignDocumentTokenDtoGen) {
    this.$log.debug(`Change Type ${isQrCode}`);

    let signatureToken: SignatureTokenConfigType = SignatureQRTokenConfig;
    if (!isQrCode) {
      signatureToken = SignatureImageTokenConfig;
    }

    const x = token.coordinates.x + token.coordinates.w / 2 - signatureToken.w / 2;
    const y = token.coordinates.y + token.coordinates.h / 2 - signatureToken.h / 2;
    token.coordinates.x = x;
    token.coordinates.y = y;
    token.coordinates.h = signatureToken.h;
    token.coordinates.w = signatureToken.w;
    token.token = signatureToken.token;
  }

  get isSignatureFormActive() {
    return FeatureModule.isSignatureFormActive;
  }

  save() {
    this.$emit("save");
    this.unselect();
  }

  unselect() {
    DocumentTemplateModule.setHighlightedToken(-1);
  }

  getIsSignature(token: string) {
    return isSignatureToken(token);
  }

  getIsCrossToken(token: string) {
    return isCrossToken(token);
  }

  getIsTextField(token: string) {
    return SignatureTokenEnum.FREE_TEXT_TOKEN === token;
  }

  updateCrossToken(documentToken: SignDocumentTokenDtoGen) {
    documentToken.value = documentToken.value !== SignatureTokenEnum.CROSS_TOKEN ? SignatureTokenEnum.CROSS_TOKEN : "";
  }

  removeDocumentToken(documentToken: SignDocumentTokenDtoGen) {
    DocumentTemplateModule.removeDocumentToken({ page: this.selectedPage, documentToken });
    this.$emit("save");
    this.unselect();
  }

  updateToken(documentToken: SignDocumentTokenDtoGen, newToken: string) {
    documentToken.token = newToken;
  }
}
